import { Pipe, PipeTransform } from '@angular/core';
import { TEAM } from '@rma/common-ui-domain/types';

@Pipe({
  name: 'autoSearchGroupingLabel',
  standalone: true,
})
export class AutoSearchGroupLabelPipe implements PipeTransform {
  transform(groupingType: string | undefined, agentCount = 0): string {
    if (!groupingType) {
      return '';
    }
    const baseTranslation = groupingType === TEAM ? 'team' : 'office';
    const suffix = agentCount !== 0 ? 'Agents' : '';
    return `result.autoSearch.${baseTranslation}${suffix}`;
  }
}
